import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { IntakeService } from '../services/intake.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonFunctions } from '@shared/util/common-functions';
import { Utilities } from '@app/core/utils/utilities';
import { ConstantVariables } from '@app/shared/util/constant-variables';
import { LoaderService } from '@app/core/services/loader.service';
import { QuillModule } from 'ngx-quill';

@Component({
    selector: 'app-add-intl-application-notes',
    imports: [CommonModule, SharedModule, QuillModule],
    templateUrl: './add-intl-application-notes.component.html',
    styleUrl: './add-intl-application-notes.component.css'
})
export class AddIntlApplicationNotesComponent {
  commonFn = inject(CommonFunctions);
  intakeService = inject(IntakeService);
  intakeId = inject(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<AddIntlApplicationNotesComponent>);
  constantVariable = inject(ConstantVariables);
  notesCharCount$ = signal<number>(0);
  totalCharCount$ = signal<number>(4000);
  showErrorMsg$ = signal<boolean>(false);
  util = inject(Utilities);
  loaderService = inject(LoaderService);
  intlNotes: string = '';
  institutionId = JSON.parse(localStorage.getItem("institutionDetails") ?? '')?.institutionId;

  clearIntlNotes() {
    this.intlNotes = '';
    this.getCharCount();
  }

  getCharCount() {
    if(this.constantVariable.ckEditorStyleRemoval.test(this.intlNotes?.trim()))
      this.intlNotes = this.util.decodeHTMLEntities(this.intlNotes?.trim()?.replace(this.constantVariable.ckEditorStyleRemoval, ''));
    if (this.intlNotes) this.intlNotes = this.util.encodeToHTML(this.intlNotes);
    this.notesCharCount$.set(this.intlNotes?.length);
    if (this.showErrorMsg$() && this.intlNotes?.trim()?.length <= this.totalCharCount$())
      this.showErrorMsg$.set(false);
    else if (this.intlNotes?.trim()?.length > this.totalCharCount$())
      this.showErrorMsg$.set(true);
  }

  saveIntlNotesData() {
    if (this.intlNotes?.trim()?.length > this.totalCharCount$()) {
      this.showErrorMsg$.set(true);
    } else {
      const intlNotesData: any = { intakeAppNotes: this.util.decodeHTMLEntities(this.intlNotes?.trim()?.replace(this.constantVariable.ckEditorStyleRemoval, '')) }
      if (this.util.getStoredUserDetails().userId)
        intlNotesData['createdBy'] = Number(this.util.getStoredUserDetails().userId);
      this.intakeService.saveIntlNotesData(this.institutionId, this.intakeId, intlNotesData).subscribe((res: any) => {
        const successMessage = (res?.intakeAppNoteId) ? "International application notes has been successfully added." : "";
        this.dialogRef.close(successMessage);
        this.loaderService.forceCloseOverlay();
      })
    }
  }
}
